export const getSiteInfo = async () => {

    const response = await fetch(
      `${process.env.NEXT_PUBLIC_BASE_CMS}/api/faq/getBody`,
     // 'http://localhost:3000/api/faq/getBody',
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          // "X-CSRFToken": cookies.get("boho_csrf"),
          // "X-CSRF-Token": cookies.get("boho_csrf"),
        },
       // body: new URLSearchParams(data),
        credentials: "include",
      },
    );
  
    //   return response;
    if (response.status === 200) {
      const data = response.json();
      return data;
    }
  };